import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, FormArray, ReactiveFormsModule } from '@angular/forms';
import { ListService } from '../_services/list.service';
import { WinkelService } from '../_services/winkel.service';
import { ActiveListService } from '../_services/active-list.service';
import { CacheService } from '../_helper/CacheService';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    imports: [ReactiveFormsModule, MatFormFieldModule, CdkAccordionModule,
        MatIconModule, MatAutocompleteModule, MatInputModule, MatButtonModule, MatSelectModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {

  item: string[];
  form: UntypedFormGroup;
  showExisting = false;
  shops: { id: number; name: string }[] = [];
  filteredShops: string[] = [];
  filteredOptions: string[] = [];
  private allOptions: string[] = [];
  activeListName = 'Boodschappenlijst';

  constructor(
    private listService: ListService,
    private winkelService: WinkelService,
    private activeListService: ActiveListService,
    private cacheService: CacheService,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activeListName = this.activeListService.getListName();
    this.form = this.fb.group({
      winkel: new UntypedFormControl(''),
      products: new UntypedFormArray([new UntypedFormControl('')])
    });

    this.winkelService.getWinkels().subscribe({
      next: (data) => {
        this.shops = JSON.parse(data);
        this.filteredShops = this.shops.map(s => s.name);
        this.cdr.detectChanges();
      }
    });

    this.form.get('winkel')!.valueChanges.subscribe(val => {
      this.filteredShops = this.filterShops(val ?? '');
    });
  }

  my_handler(ev: any, ix: number, id: any): void {
    this.filteredOptions = this._filter(id.value ?? '');
    if (ix === this.allproducts.controls.length - 1 && id.value?.trim()) {
      this.addProduct();
      this.cdr.detectChanges();
    }
  }

  isEmpty = (val: any) => val == null || val.trim?.() === '' || !(Object.keys(val) || val).length;

  processResult(result: any) {
    this.item = result.length > 0 ? result.map((v: any) => v.name) : [];
    this.cdr.detectChanges();
  }

  showNumber() {
    return this.item?.length ?? 0;
  }

  loadList() {
    const winkel = this.form.value.winkel;
    if (!winkel) return;
    this.showExisting = false;
    this.listService.getListOfShop(winkel).subscribe({
      next: (result) => this.processResult(JSON.parse(result)),
    });
  }

  private filterShops(value: string): string[] {
    const v = value.toLowerCase().trim();
    if (!v) return this.shops.map(s => s.name);
    const threshold = Math.ceil(v.length / 3);
    return this.shops
      .map(s => s.name)
      .filter(name => {
        const n = name.toLowerCase();
        if (n.includes(v)) return true;
        return n.split(/\s+/).some(word => this.levenshtein(v, word) <= threshold);
      });
  }

  private levenshtein(a: string, b: string): number {
    const m = a.length, n = b.length;
    const d: number[][] = [];
    for (let i = 0; i <= m; i++) d[i] = [i];
    for (let j = 0; j <= n; j++) d[0][j] = j;
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        d[i][j] = a[i - 1] === b[j - 1]
          ? d[i - 1][j - 1]
          : 1 + Math.min(d[i - 1][j], d[i][j - 1], d[i - 1][j - 1]);
      }
    }
    return d[m][n];
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  submit() {
    const postData = this.form.value;
    this.cacheService.clear('shop_arr');
    this.listService.postNewitem(postData).subscribe({
      error: (err) => console.error(err)
    });
    this.item = [];
    this.showExisting = false;
    this.form = this.fb.group({
      winkel: new UntypedFormControl(''),
      products: new UntypedFormArray([new UntypedFormControl('')]),
    });
    this.cdr.detectChanges();
  }

  get allproducts(): UntypedFormArray {
    return this.form.get('products') as UntypedFormArray;
  }

  products(): UntypedFormArray {
    return this.form.get('products') as UntypedFormArray;
  }

  addProduct() {
    this.products().push(new UntypedFormControl());
  }

  removeProduct(i: number) {
    this.products().removeAt(i);
  }
}
